import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'next-themes'
import { Toaster } from '@/components/ui/sonner'
import { QueryProvider } from '@/lib/query-client'
import { ErrorBoundary } from '@/components/error-boundary'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
        <Toaster position="top-center" richColors />
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>
)
